<template>
	<router-link :to="url"
		:class="`btn btn-primary page-action ${additionalClass}`"
		:disabled="disabled">
		<i class="fa fa-plus"></i>
		<span>{{ label }}</span>
	</router-link>
</template>

<script>
export default {
	props: {
		additionalClass: {
			type: String,
			required: false,
			default: null,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		label: {
			type: String,
			required: false,
			default: 'Add',
		},
		url: {
			type: String,
			required: true,
		},
	}
}
</script>
